export default __webpack_public_path__ + "static/media/profile3.5dc82971.png";